<template>
  <router-view/>
</template>

<script>
import powerBI from 'store/powerbi.store';

const POWERBI_STORE = 'powerbi';

export default {
  beforeCreate() {
    this.$store.registerModule(POWERBI_STORE, powerBI);
  },
  beforeDestroy() {
    this.$store.unregisterModule(POWERBI_STORE);
  }
};
</script>
